import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";


import {apiCropImage} from '../../config';
import {fetchUserAlbums, resetUserAlbums} from "../../creators/user.albums";
import {fetchAlbumMedias, resetAlbumMedias} from "../../creators/album.medias";

import {PageLoader} from './Loader';
import Icon from './Icon';
import {Button} from "./Button";
import {fetchUserArticles, resetUserArticles} from "../../creators/user.articles";
import {CheckboxInputField, TextInputField} from "./FormField";
import ImageRotation from "./ImageRotation";

class ShareMedia extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSearch: '',
            currentIndex: 0,
            alertToggle: false,
            attachementArray: [],
            albumId: 0,
            showAlbumMedias: false,
            toggleQuickView: false,

            shareAlbum: [],
            shareMedia: [],
            shareArticle: [],
            elementToShare: []
        };
        this.thumbnail = this.thumbnail.bind(this);
        this.filterGallery = this.filterGallery.bind(this);
        this.handleAlbumMedias = this.handleAlbumMedias.bind(this);
        this.handleCheckBox = this.handleCheckBox.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.props.fetchUserAlbums(this.props.currentUserId, {
            limit: false
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.albumId !== this.state.albumId){
            this.props.resetAlbumMedias();
            this.props.fetchAlbumMedias(this.state.albumId, {
                byAlbumId: this.state.albumId,
                sort: "-createdAt",
                limit: false,
            });
        }
    }

    componentWillUnmount() {
        this.props.resetUserAlbums();
        this.props.resetAlbumMedias();
        // this.props.resetUserArticles();
        this.setState({shareAlbum: [], shareMedia: [], shareArticle: [], elementToShare: []});
    }

    handleIndex(index) {
        if(index === this.state.currentIndex){
           return null;
        } else if(index === 1){
            this.props.fetchUserArticles(this.props.currentUserId, {
                limit: false,
                sort: "-createdAt",
            });
        } else {
            this.props.fetchUserAlbums(this.props.currentUserId, {
                limit: false
            });
        }

        this.setState({currentIndex: index, showAlbumMedias: false});
    }

    handleAlbumMedias(id){
        this.setState({albumId: id, showAlbumMedias: true});
    }

    handleCheckBox(name, value){
        let array = this.state[name];
        let elementToShare = this.state.elementToShare;
        if(!array.includes(value._id)){
            array.push(value._id);
            elementToShare.push(value);
        } else {
            array = array.filter(item => item !== value._id);
            elementToShare = elementToShare.filter(item => item._id !== value._id);
        }
        this.setState({[name] : array, elementToShare});
    }


    filterGallery(list) {
        if (!list) {
            list = []
        }
        if (this.state.currentSearch && this.state.currentSearch.length >= 1) {
            let filterList = [];
            let search = this.state.currentSearch;
            list.forEach(item => {
                //item.username = '@'+item.username;
                if (item.title.toLowerCase().includes(search.toLowerCase())) {
                    filterList.push(item);
                }
            });
            return filterList;
        } else {
            return list;
        }
    }


    thumbnail(props) {
        if (props.previewUrl) {
            let mediaType = props.kind;
            return (
                <Fragment key={props._id}>
                    {(mediaType === 'video') ? (
                        <Fragment>
                            <ImageRotation
                                srcs={Array.isArray(props.previewUrl) && props.previewUrl.map(src => apiCropImage({
                                    url: src,
                                    width: 80,
                                    height: 80
                                }))}
                                interval={600}
                                alt={props.title}
                            />
                            <div className="btn-play">
                                <Icon type="play-video"/>
                            </div>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <img alt={""} src={apiCropImage({url: props.previewUrl, width: 80, height: 80})}/>
                        </Fragment>
                    )}
                </Fragment>
            )
        } else return null
    }

    handleSubmit(){
        let sharedAlbum = [];
        let sharedMedia = [];
        let sharedArticle = [];

        this.state.shareAlbum.forEach((item) => {
            sharedAlbum.push({type: "album", _id: item})
        });

        this.state.shareMedia.forEach((item) => (
            sharedMedia.push({type: "media", _id: item})
        ));

        this.state.shareArticle.forEach((item) => (
            sharedArticle.push({type: "articles", _id: item})
        ));

        this.props.handleSubmit([...sharedAlbum, ...sharedMedia, ...sharedArticle]);
        this.props.handleClose();
    }

    render() {
        return (
            <div className="modal-container import-media" >
                <div className={"modal-topline"}>
                    <div className="head-title bottom-border full row align-center justify-space-between">
                        Votre bibliothèque de média
                        <span className={"cursor-pointer"} onClick={this.props.handleClose}><Icon type="close"/></span>
                    </div>
                </div>
                <div className="import-media-nav">
                    <ul className="sidebar-menu row-style">
                        <li className={`${this.state.currentIndex === 0 ? 'active' : ''} side-menu-item`}
                            onClick={() => this.handleIndex(0)}>
                            Media
                        </li>

                        <li className={`${this.state.currentIndex === 1 ? 'active' : ''} side-menu-item`}
                            onClick={() => this.handleIndex(1)}>
                            Articles
                        </li>
                    </ul>
                    <TextInputField placeholder={`Rechercher le nom ${this.state.currentIndex === 1 ? "d'un article" : this.state.showAlbumMedias ? "d'une image" : "d'un album"}`}
                                    value={this.state.currentSearch}
                                    onChange={(event) => this.setState({currentSearch: event.target.value})}/>
                    {this.state.showAlbumMedias && (
                        <Button onClick={()=>this.setState({showAlbumMedias: false, albumId: 0})}
                                btnStyle={"primary-reverse"}
                                size={"small"}
                                className={"back-btn"}
                                content={"Retour"}/>
                    )}
                </div>
                <div className={"modal-body"}>
                    <div className={`grid ${this.state.currentIndex === 0 ? 'active' : ''}`}>
                        {this.props.userAlbumsLoading || this.props.albumMediasLoading ? (
                            <PageLoader />
                        ) : (
                            <Fragment>
                                {this.state.showAlbumMedias ? (
                                    <Fragment>
                                        {this.props.albumMediasTotal === 0 && (
                                            <div className={"no-content"}>Aucun medias</div>
                                        )}
                                        {this.filterGallery(this.props.albumMedias).map(media => {
                                            let mediaInclude = this.state.shareMedia.includes(media._id);
                                            return (
                                                <div className={"media list"} key={media._id}>
                                                    <CheckboxInputField onChange={()=>this.handleCheckBox("shareMedia", media)}
                                                                        checked={mediaInclude} />
                                                    <div className={"thumb"}>
                                                        {this.thumbnail({...media})}
                                                    </div>
                                                    <div className={"title"} onClick={()=>this.handleCheckBox("shareMedia", media)}>{media.title}</div>
                                                    <div className={"options"}>
                                                        <div className={mediaInclude ? "delete" : "share"} onClick={()=>this.handleCheckBox("shareMedia", media)}>{mediaInclude ? "Désélectionner" : "Partager"}</div>
                                                    </div>
                                                </div>
                                            )}
                                        )}
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        {this.props.userAlbumsTotal === 0 && (
                                            <div className={"no-content"}>Aucun album</div>
                                        )}
                                        {this.filterGallery(this.props.userAlbums).map(album => {
                                            let albumInclude = this.state.shareAlbum.includes(album._id);
                                            return (
                                                <div className={"list"} key={album._id}>
                                                    <CheckboxInputField onChange={()=>this.handleCheckBox("shareAlbum", album)}
                                                                        checked={albumInclude} />
                                                    <div className={"folder"} onClick={()=>this.handleAlbumMedias(album._id)}><Icon type={"folder"} /></div>
                                                    <div className={"title"} onClick={()=>this.handleAlbumMedias(album._id)}>{album.title}</div>
                                                    <div className={"options"}>
                                                        <div className={albumInclude ? "delete" : "share"} onClick={()=>this.handleCheckBox("shareAlbum", album)}>{albumInclude ? "Désélectionner" : "Partager"}</div>
                                                        <div className={"enter"} onClick={()=>this.handleAlbumMedias(album._id)}>Voir les medias</div>
                                                    </div>
                                                </div>
                                            )}
                                        )}
                                    </Fragment>
                                )}
                            </Fragment>
                            )}
                        </div>

                        <div className={`grid ${this.state.currentIndex === 1 ? 'active' : ''}`}>
                            {this.props.userArticlesLoading ? (
                                <PageLoader />
                            ) : (
                                <Fragment>
                                    {this.props.userArticlesTotal === 0 && (
                                        <div className={"no-content"}>Aucun article</div>
                                    )}
                                    {this.filterGallery(this.props.userArticles).map((article) => {
                                        let articleInclude = this.state.shareArticle.includes(article._id);
                                        return(
                                            <div className={"list"} key={article._id}>
                                                <CheckboxInputField onChange={()=>this.handleCheckBox("shareArticle", article)}
                                                                    checked={articleInclude} />
                                                <div className={"article"}><Icon type={"article"} /></div>
                                                <div className={"title"} onClick={()=>this.handleCheckBox("shareArticle", article)}>{article.title}</div>
                                                <div className={"options"}>
                                                    <div className={articleInclude ? "delete" : "share"} onClick={()=>this.handleCheckBox("shareArticle", article)}>{articleInclude ? "Désélectionner" : "Partager"}</div>
                                                </div>
                                            </div>
                                        )}
                                    )}
                                </Fragment>
                            )}
                        </div>
                </div>
                <div className={"modal-baseline"}>
                    <span className={"selection-count"}>
                        selection : {this.state.shareAlbum.length} album{this.state.shareAlbum.length > 1 ? "s" : ""}, {this.state.shareMedia.length} media{this.state.shareMedia.length > 1 ? "s" : ""}, {this.state.shareArticle.length} article{this.state.shareArticle.length > 1 ? "s" : ""}
                    </span>
                    <Button size={"small"}
                            btnStyle={"grey"}
                            onClick={() => this.props.handleClose()}
                            content={"Annuler"}/>
                    <Button size={"small"}
                            btnStyle={"primary-reverse"}
                            onClick={() => this.handleSubmit()}
                            content={"Valider"}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUserId: state.currentUser.data && state.currentUser.data._id,

        userAlbums: state.userAlbums.data,
        userAlbumsLoading: state.userAlbums.loading,
        userAlbumsTotal: state.userAlbums.total,

        albumMedias: state.albumMedias.data,
        albumMediasLoading: state.albumMedias.loading,
        albumMediasTotal: state.albumMedias.total,

        userArticles: state.userArticles.data,
        userArticlesLoading: state.userArticles.loading,
        userArticlesTotal: state.userArticles.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserAlbums,
    resetUserAlbums,

    fetchAlbumMedias,
    resetAlbumMedias,

    fetchUserArticles,
    resetUserArticles
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ShareMedia);
